import i18n from "i18n";
import { UserRole } from "components/Reports/reportAssets/assets";

export type controllerData = {
  id?: string;
  tz: string;
  fullName?: string;
  phoneNumber?: string;
  email?: string;
  password?: string;
  registerDate: string;
  lastReportUpdate: string;
  specialtiesCodeList?: number[];
  rolesCodeList: number[];
  disable?: boolean;
  isAutographPictureExist?: boolean;
};

export type updateControllerData = {
  controllerId?: string;
  fullName?: string;
  phoneNumber?: string;
  email?: string;
  rolesCodeList?: number[];
  password?: string;
  tz: string;
  specialtiesCodeList?: number[];
};

export type newControllerData = {
  fullName: string;
  phoneNumber: string;
  email: string;
  rolesCodeList: number[];
  specialtiesCodeList?: number[];
  password: string;
  tz: string;
};

export type ValidationControllerData = {
  fullName: string;
  phoneNumber: string;
  email: string;
  password: string;
  rolesCodeList: number[];
  tz: string;
};

export const specialties = [
  {
    value: 1,
    label: i18n.t("חציית קו הפרדה"),
  },
  {
    value: 2,
    label: i18n.t("רמזור אדום"),
  },
  {
    value: 3,
    label: i18n.t("מעבר חצייה"),
  },
  {
    value: 4,
    label: i18n.t("עקיפה"),
  },
  {
    value: 5,
    label: i18n.t("other"),
  },
];

export const ControllerRoles = [
  {
    value: UserRole.REGULAR,
    label: i18n.t("regularController"),
  },
  {
    value: UserRole.SENIOR,
    label: i18n.t("seniorController"),
  },
  {
    value: UserRole.CONTROLCENTER,
    label: i18n.t("controlCenter"),
  },
  {
    value: UserRole.SENIOR_WATCH,
    label: i18n.t("seniorForWatch"),
  },
];

export const verifyStatuses = [
  {
    value: 0,
    label: i18n.t("notVerified"),
  },
  {
    value: 1,
    label: i18n.t("verified"),
  },
];

export type ControllersListQueryBody = {
  fullName?: string;
  userRole?: number;
  registrationDate?: string;
  lastReportUpdate?: string;
  specialization?: number;
};
export type ControlerFilters = {
  id?: number;
  filterName: string;
  fullName?: string;
  registrationDate: Date;
  lastReportUpdate: Date;
  userRole: number;
  specialization: number;
};
